import { autorun, makeAutoObservable, runInAction } from 'mobx'
import { storeLocal, storeSession } from '../../helpers/stores'
import { parseUser } from '../../helpers/project.controller'
import { FormEvent } from 'react'
import { openApi } from '../../helpers/request'
import store from 'store'
import { notification } from 'antd'
import userController from '../../front/user/controllers/user.controller'
import { config } from "../../config/app";

export type ThemeMode = 'system' | 'light' | 'dark'

const darkSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)')

class layoutController {

    wl: any = {}

    config = {
        token: {
            colorPrimary: '#000000',
            fontFamily: "Gilroy",
        }
    }

    mobile = false

    // Выбор пользователя; 'system' — тема как в настройках ОС (по умолчанию)
    themeMode: ThemeMode = ['light', 'dark'].includes(storeLocal.get('theme')) ? storeLocal.get('theme') : 'system'

    systemDark = darkSchemeQuery.matches

    user: any = {
        firstname: '',
        lastname: '',
        super: 0,
        project: {},
    }

    project: any = {}

    search = ''

    markers: any = {}

    bundles: any[] = []

    constructor() {
        makeAutoObservable(this)

        darkSchemeQuery.addEventListener('change', e => runInAction(() => this.systemDark = e.matches))
        autorun(() => document.documentElement.dataset.theme = this.theme)
    }

    get theme(): 'light' | 'dark' {
        if (this.themeMode === 'system') return this.systemDark ? 'dark' : 'light'

        return this.themeMode
    }

    setThemeMode(mode: ThemeMode) {
        this.themeMode = mode

        if (mode === 'system') storeLocal.remove('theme')
        else storeLocal.set('theme', mode)
    }

    getBundles() {
        // openApi('get', '/manager/projects/')
        //     .then(result => {
        //         console.log(result)
        //         // runInAction(() => this.bundles = result)
        //     })
    }

    getMarkers() {
        openApi('get', 'markers')
            .then(result => {
                runInAction(() => this.markers = result.data)
            })
    }

    getWL(host: string) {
        if(!store.get('wl')) {
            const data = new FormData()
            data.append('Client-Domain', host)

            openApi('post', 'wl', data)
              .then(result => {
                  console.log(result)
                  runInAction(() => {
                      this.wl = result.data
                      store.set('wl', result.data)
                      const favicon = document.getElementById("favicon")

                      this.config.token.colorPrimary = result.data.primary_color
                      document.documentElement.style.setProperty('--primary-color', result.data.primary_color)
                      // @ts-ignore
                      favicon.href = this.wl.favicon
                      config.defaultCountry = this.wl.country_phone_code ? this.wl.country_phone_code : config.defaultCountry
                  })
              })
              .catch(err => {
                  console.log(err)
                  console.log(err.response)
              })
        } else {
            this.wl = store.get('wl')
            this.config.token.colorPrimary = this.wl.primary_color
            document.documentElement.style.setProperty('--primary-color', this.wl.primary_color)
            const favicon = document.getElementById("favicon")
            // @ts-ignore
            favicon.href = this.wl.favicon

            config.defaultCountry = this.wl.country_phone_code ? this.wl.country_phone_code : config.defaultCountry
        }
    }

    setMobile() {
        runInAction(() => this.mobile = !this.mobile)
    }

    logout() {
        storeLocal.clearAll()
        if (this.themeMode !== 'system') storeLocal.set('theme', this.themeMode)
        storeSession.clearAll()
        window.location.href = '/'
        return false
    }

    async getProject() {
        const project = await userController.decrypt('project')

        if(project) {
            runInAction(() => this.project = project)
        }
    }

    onChangeSearch(value: string) {
        runInAction(() => this.search = value)
    }

    searchProducts(e: FormEvent) {
        e.preventDefault()
        window.location.href = "/shop/search?name=" + this.search
    }

    openNotification(data: any) {
        console.log('socket', data)
        if(data.type === 'info' || data.type === 'success' || data.type === 'warning' || data.type === 'error') {
            // @ts-ignore
            notification[data.type]({
                message: data.data.title,
                description: data.data.description,
            })
        } else {
            if(data.type === 'markers') {
                runInAction(() => this.markers = data.data)
            }
        }
    }

}

export default new layoutController()